import Heading from '@atlaskit/heading';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import React from 'react';
import { Page } from './Page';

const styles = cssMap({
	content: {
		paddingBlock: token('space.1000'),
		textAlign: 'center',
		gap: token('space.600'),
		maxWidth: '800px',
		marginInline: 'auto',
	},
});

export const NoAppsAvailablePage = (): React.JSX.Element => {
	return (
		<Page>
			<Flex xcss={styles.content} direction="column" alignItems="center">
				<Heading size="xlarge">No apps available</Heading>
				<Text color="color.text.subtlest">
					You do not currently have access to any Teamwork Graph apps.
				</Text>
			</Flex>
		</Page>
	);
};
